/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLogicalLayerObject = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M6.084 16h4.76v-1.39h-3.2V8.73h-1.56zm8.677.14c1.094 0 1.934-.327 2.52-.98.587-.66.88-1.593.88-2.8 0-1.193-.296-2.12-.89-2.78-.593-.66-1.43-.99-2.51-.99s-1.916.33-2.51.99c-.593.66-.89 1.587-.89 2.78 0 1.207.294 2.14.88 2.8.594.653 1.434.98 2.52.98zm0-1.33c-.606 0-1.06-.21-1.36-.63-.293-.42-.44-1.027-.44-1.82s.147-1.397.44-1.81c.3-.42.754-.63 1.36-.63.607 0 1.057.21 1.35.63.3.413.45 1.017.45 1.81s-.15 1.4-.45 1.82c-.293.42-.743.63-1.35.63z" />
        <path d="M2 22V2h20v20zm2-2h16V4H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgLogicalLayerObject as LogicalLayerObject };
